
import { ChevronRightIcon } from 'lucide-react';
import React from 'react';

interface FoldOutButtonProps {
    isExpanded: boolean;
    toggle: (key: string) => void;
    keyValue: string;
}

const FoldOutButton: React.FC<FoldOutButtonProps> = ({ isExpanded, toggle, keyValue }) => {
    return (
        <button
            className={`mr-2 inline-flex items-center transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''
                }`}
            onClick={(e) => {
                e.stopPropagation();
                toggle(keyValue);
            }}
        >
            <ChevronRightIcon className="h-4 w-4 text-gray-700" />
        </button>
    );
};

export default FoldOutButton;